import React, { useEffect, useRef, useState } from "react";
import { VisuallyHidden } from "@streeteasy/design-system/style-utilities/visually-hidden";
import { func, string } from "prop-types";

import { locations } from "../../propTypes";
import LocationFilterModal from "../LocationFilterModal";
import LocationFilterTrigger from "../LocationFilterTrigger";
import * as S from "./styled";

const LocationFilterWidget = ({
  areaOptions,
  className,
  initialSelectedAreas,
  onApply,
  rootElementId
}) => {
  const [isLocationFilterModalOpen, setLocationFilterModalOpen] = useState(
    false
  );
  const triggerRef = useRef();
  const [dimensions, setDimensions] = useState({ left: 0, top: 0, width: 0 });
  const [selectedAreas, setSelectedAreas] = useState(initialSelectedAreas);
  const describedbyTextId = "location-filter-widget-describedby-text";
  const describedbyTitleId = "location-filter-widget-describedby-title";

  const updateDimensions = el => {
    if (el) {
      const boundingRect = el.getBoundingClientRect();

      setDimensions({
        left: boundingRect.left,
        top: boundingRect.top,
        width: boundingRect.width
      });
    }
  };

  useEffect(() => {
    updateDimensions(triggerRef.current);

    const windowChangeHandler = () => {
      updateDimensions(triggerRef.current);
    };

    global.addEventListener("scroll", windowChangeHandler);
    global.addEventListener("resize", windowChangeHandler);

    return () => {
      global.removeEventListener("scroll", windowChangeHandler);
      global.removeEventListener("resize", windowChangeHandler);
    };
  }, [triggerRef]);

  useEffect(() => {
    setSelectedAreas(initialSelectedAreas);
  }, [initialSelectedAreas]);

  const closeLocationFilterModal = () => {
    setLocationFilterModalOpen(false);
  };

  const openLocationFilterModal = () => {
    updateDimensions(triggerRef.current);
    setLocationFilterModalOpen(true);
  };

  const applyHandler = areas => {
    onApply(areas);
    setSelectedAreas(areas);
    closeLocationFilterModal();
  };

  return (
    <div className={className}>
      <S.TriggerTitle id={describedbyTitleId}>Location</S.TriggerTitle>
      <LocationFilterTrigger
        ref={triggerRef}
        aria-describedby={`${describedbyTitleId} ${describedbyTextId}`}
        onClick={openLocationFilterModal}
        selectedAreas={selectedAreas}
      />
      <VisuallyHidden id={describedbyTextId}>
        Click this button to edit your list of selected areas
      </VisuallyHidden>
      <LocationFilterModal
        areaOptions={areaOptions}
        dimensions={dimensions}
        initialSelectedAreas={selectedAreas}
        isOpen={isLocationFilterModalOpen}
        onApply={applyHandler}
        onClose={closeLocationFilterModal}
        rootElementId={rootElementId}
      />
    </div>
  );
};

LocationFilterWidget.propTypes = {
  areaOptions: locations.isRequired,
  className: string,
  initialSelectedAreas: locations,
  onApply: func.isRequired,
  rootElementId: string.isRequired
};

LocationFilterWidget.defaultProps = {
  initialSelectedAreas: [],
  className: null
};

export default LocationFilterWidget;
